import _ from 'lodash';

export default function(value) {
    let subscribers = [];

    const getValue = () => value,
        publish = (nextValue) => {
            value = nextValue;

            subscribers.forEach((cb) => cb(_.cloneDeep(value)));
        },
        subscribe = (callback) => {
            subscribers.push(callback);

            return () => subscribers = subscribers.filter((cb) => cb !== callback);
        };

    return { getValue, publish, subscribe };
}



// WEBPACK FOOTER //
// ./src/context/createEmitter.js